import {Column} from "@tanstack/react-table";
import {default as classNames} from "classnames";
import {CSSProperties, MouseEvent} from "react";

import styles from "./TableMarkup.module.scss";

/**
 * A row/cell click handler that navigates must ignore clicks the row's own links and buttons
 * already handled, otherwise it acts on top of them - e.g. a link navigating twice, which
 * pushes a duplicate history entry and leaves the browser back button looking broken.
 */
export const isClickHandledByRowContent = (event: MouseEvent): boolean =>
  event.defaultPrevented || !!(event.target as Element).closest?.("a, button");

export const getPinnedCellProps = <TData>(
  column: Column<TData, unknown>
): {className?: string; style?: CSSProperties} => {
  const pinned = column.getIsPinned();
  if (!pinned) {
    return {};
  }
  const isLeft = pinned === "left";
  const isBoundary = isLeft ? column.getIsLastColumn("left") : column.getIsFirstColumn("right");
  return {
    className: classNames(isLeft ? styles.pinnedLeft : styles.pinnedRight, {
      [isLeft ? styles.pinnedLeftBoundary : styles.pinnedRightBoundary]: isBoundary,
    }),
    // sticky offsets are cumulative (https://tanstack.com/table/v8/docs/framework/react/examples/column-pinning-sticky),
    // so they must be inline — computed from the widths of the preceding pinned columns
    style: {
      [isLeft ? "left" : "right"]: isLeft ? column.getStart("left") : column.getAfter("right"),
      width: column.getSize(),
    },
  };
};
